import { useRouteError } from 'react-router-dom'
import type { FallbackRender } from '@sentry/react/types/errorboundary'

import { handleUnknownError } from '@jotta/types/AppError'
import { useVersion } from '@jotta/utils/frontendbackend'

import { Headline1 } from '../../Typography/Headline/Headline'

import { BaseErrorPage } from './BaseErrorPage'

export const ErrorPageBasic = ({
  error,
}: {
  error: Error
  resetError?: () => void
}) => {
  const version = useVersion()

  return (
    <BaseErrorPage reportError={error}>
      <Headline1>{error.name}</Headline1>
      <p>{`${version ? [{ version }] : ''} ${error.message}`}</p>
      <a href={window.location.href} className="link">
        refresh
      </a>
    </BaseErrorPage>
  )
}

export const ErrorPageBasicFallback: FallbackRender = ({ error }) => (
  <ErrorPageBasic error={error} />
)

export function ErrorPageBasicElement() {
  const error = useRouteError()
  return <ErrorPageBasic error={handleUnknownError(error)} />
}
